export default "__VITE_ASSET__BRcNjyij__"